import InputGroupContent from '@/components/elements/input'
import Select from '@/components/elements/select'
import { Box, Flex, Heading } from '@chakra-ui/react'
import Submit from '@/components/elements/submit'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { categoriesSchema } from '@/entities/schemas/categories'
import Toast from '@/components/elements/toast'
import { useState } from 'react'
import SpinnerLoading from '@/components/elements/spinner'
import { createCategory } from '@/services/api/categories/categories'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import { categoryRefrestUpdate, sessionRefrestUpdate } from '@/store/features/state'
import { addCategoryFn } from '@/store/features/categories'
import { categoryOptions } from '@/utils/maps/categories-maps'
import CategoriesEntity from '@/entities/api/categories/categories'
import { useFormErrorToast } from '@/hooks/useFormErrorToast'

const AddCategory = ({ close }: { close: () => void }) => {
	const token = useSelector((state: RootState) => state.auth.token)
	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm<CategoriesEntity>({
		resolver: yupResolver(categoriesSchema),
	})
	useFormErrorToast(errors)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const dispatch = useDispatch<AppDispatch>()

	const onSubmit = async (dataYup: Partial<CategoriesEntity>) => {
		try {
			setIsLoading(true)
			const response = await createCategory(token ?? '', {
				type: dataYup.type,
				name: dataYup.name,
			})

			if (response?.status === 500 || response?.status === 409) {
				Toast({ type: 'error', message: 'Hubo un error al crear la categoria' })
				return
			}
			if (response?.status === 401) {
				dispatch(sessionRefrestUpdate())
				return
			}

			dispatch(addCategoryFn(response?.data?.data))
			Toast({ type: 'success', message: 'Se creo correctamente' })
			dispatch(categoryRefrestUpdate())
			setIsLoading(false)
			close()
		} catch (error) {
			Toast({ type: 'error', message: 'Algo salió mal al crear la categoría' })
			setIsLoading(false)
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Flex w='100%' h='full' flexDirection='column' alignItems='center'>
				<Box
					w='full'
					display='flex'
					justifyContent='start'
					alignItems='center'
					mb='2'
				>
					<Heading
						as='h4'
						fontSize={{ base: 'lg', md: 'xl' }}
						color='black'
						fontWeight='900'
					>
						Información general
					</Heading>
				</Box>
				<InputGroupContent
					label='Nombre de la categoría'
					placeholder='Ingresa el nombre de la categoría'
					name='name'
					type='text'
					register={register}
					errors={errors}
				/>
				<Select
					name='type'
					label='Categoría padre'
					placeholder='Selecciona una categoría padre'
					options={categoryOptions}
					control={control}
					isRequired={true}
				/>
				<Box pt='4' pb='8'>
					{isLoading ? <SpinnerLoading /> : <Submit text='Agregar categoría' />}
				</Box>
			</Flex>
		</form>
	)
}

export default AddCategory
